export default __webpack_public_path__ + "static/media/Ballroll_00286.b758acfc.png";